import { apiGet, apiPost } from './index'

export type ThemePreference = 'light' | 'dark' | 'system'

export interface MeStationListenerCounts {
  show_listener_counts: boolean
  listener_count_endpoint: string | null
}

export interface MeStation {
  id: number
  name: string
  role?: string
  timezone: string
  listener_counts?: MeStationListenerCounts
  general?: {
    auto_send_quick_replies: boolean
  }
}

export interface MeUser {
  id: number
  name: string
  email?: string
  roles?: string[]
  capabilities?: string[]
}

export interface MeResponse {
  user: MeUser
  stations: MeStation[]
  theme: ThemePreference
  roles?: string[]
  capabilities?: string[]
  tools?: {
    youtube_mp3_downloader?: boolean
  }
  dev?: {
    fakeFeedAvailable: boolean
    fakeFeedEnabled: boolean
    fakeFeedStationId?: number | null
  }
}

export async function getMe(): Promise<MeResponse> {
  return apiGet<MeResponse>('me')
}

export async function setTheme(theme: ThemePreference): Promise<{ success: boolean } | undefined> {
  return apiPost<{ success: boolean } | undefined>('me/theme', { theme })
}

export async function logout(): Promise<{ logged_out: boolean }> {
  return apiPost<{ logged_out: boolean }>('me/logout')
}
